import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import MenuItem from 'apollo-react/components/MenuItem';
import Paper from 'apollo-react/components/Paper';
import React from 'react';
import Select from 'apollo-react/components/Select';
import Typography from 'apollo-react/components/Typography';

import { MessageFrequencyCapping } from '../../constants';

export const getChannelDisplayName = (channels, channelCode) => {
  if (channels.length && channelCode) {
    const displaNname = channels.find(e => e.channelCode === channelCode).channelDisplayName;
    return displaNname;
  }
};

const MessageCappingConfigurationPage = ({
  intl,
  classes,
  periods,
  channels,
  hasValue,
  timePeriod,
  limitTime,
  channel,
  change,
  activityType,
  status,
}) =>
  _.includes(activityType, MessageFrequencyCapping) && (
    <Paper className={classes.configurationPageWrapper} elevation={2}>
      <Typography variant="overline">
        {intl.formatMessage({ id: 'journeyBuilder.activityTypes_MessageCapping' })}
      </Typography>
      <Select
        name="channel"
        label={intl.formatMessage({ id: 'journeyBuilder.channel' })}
        value={channel}
        fullWidth
        required
        canDeselect={false}
        onChange={e => {
          change('channel', e.target.value);
        }}
        disabled={status}
      >
        {channels.map(e => (
          <MenuItem key={e.channelDisplayName} value={e.channelCode}>
            {e.channelDisplayName}
          </MenuItem>
        ))}
      </Select>
      <Select
        name="timePeriod"
        label={intl.formatMessage({ id: 'journeyBuilder.timePeriod' })}
        value={timePeriod}
        fullWidth
        required
        canDeselect={false}
        onChange={e => {
          change('timePeriod', e.target.value);
        }}
        disabled={status}
      >
        {periods.map(e => (
          <MenuItem key={e.value} value={e.value}>
            {intl.formatMessage({ id: `journeyBuilder.${e.name}` })}
          </MenuItem>
        ))}
      </Select>
      {channel &&
        timePeriod &&
        (limitTime && hasValue ? (
          <Typography variant="body2">
            <FormattedMessage
              id="journeyBuilder.configurationPageNonification1"
              values={{
                channel: getChannelDisplayName(channels, channel),
                timePeriod,
                limitTime,
              }}
            />
          </Typography>
        ) : (
          <Typography variant="body2">
            <FormattedMessage
              id="journeyBuilder.configurationPageNonification2"
              values={{
                channel: getChannelDisplayName(channels, channel),
                timePeriod,
              }}
            />
          </Typography>
        ))}
    </Paper>
  );

MessageCappingConfigurationPage.displayName = 'MessageCappingConfigurationPage';
export default MessageCappingConfigurationPage;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/components/MessageCappingConfigurationPage/MessageCappingConfigurationPage.js